import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Navbar from "./components/Navbar";
import Home from "./pages/home";
import About from "./pages/about";
import Exp from "./pages/exp";
import Project from "./pages/project";
import Contact from "./pages/contact";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar/>
        <Home/>
        <About/>
        <Exp/>
        <Project/>
        <Contact/>
      </BrowserRouter>
    </>
  );
}

export default App;
